/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Tabs, Tab, Paper, Typography } from '@material-ui/core'

import Screens from './Screens/Screens'


const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
  })(Tabs);
  
  const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(2),
      padding : theme.spacing(1),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#40a9ff',
      },
    },
    selected: {},
  }))((props) => <Tab disableRipple {...props} />);

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

class UIConfig extends Component {
    state = {
        cur_tab : 0
    }
    screenHeight = React.createRef()

    handleTabChange = (event, newValue) => {
        this.setState({...this.state, cur_tab : newValue})
    }

    renderTabs = () => {
        return (
          <Paper square>
            <Tabs
              value={this.state.cur_tab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.handleTabChange}
              aria-label="Display Config Tabs"
            >
              <Tab label="Screens" />
            </Tabs>
          </Paper>
        )
    }

    renderTabContent = () => {
        switch (this.state.cur_tab) {
            case 0 :
              return this.renderScreens()
            default :
              return null
        }
    }

    renderScreens = () => {
        return (
            <Screens/>
        )
    }

    render() { 
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div 
                ref = {this.screenHeight}
                style = {{
                    boxSizing : 'border-box',
                    width : '100%',
                    height : 'calc(100vh - 48px)',
                    display: 'flex',
                    flexDirection : 'column'
                }}>
                    <Paper square style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography variant = 'button'>User Interface Config</Typography>
                    </Paper>
                    {this.renderTabs()}
                    {this.renderTabContent()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(UIConfig);